module.exports = __webpack_public_path__ + "static/media/siri34.fe445907.jpg";